import React from "react";
import { withAppState } from "../../../state";
import { SecondaryMenuStyled } from "./styles/Styled";

export const defaultFocusPath = "secondaryItem_0";

class EpgCategories extends React.Component {
  render() {
    const { items, onClick, actionState, onUpdateWheelState } = this.props;
    return (
      <SecondaryMenuStyled
        items={items.length > 0 ? items : []}
        onClick={onClick}
        hover={false}
        actionState={actionState}
        onUpdateWheelState={onUpdateWheelState}
      />
    );
  }
}

EpgCategories.defaultFocusPath = defaultFocusPath;

export default withAppState(EpgCategories);
